import { ToastProvider } from "providers";
import RoutesMap from "routes";
import GlobalStyle from "./global.styles";

const App = () => {
  return (
    <ToastProvider position="bottom-right" theme="light">
      <RoutesMap />
      <GlobalStyle />
    </ToastProvider>
  );
};

export default App;
